<script>
import { mapActions, mapState, mapGetters } from "vuex";
import scrollMixin from "@/mixins/scrollMixin";

export default {
  mixins: [scrollMixin],
  data() {
    return {
      error: null
    };
  },
  methods: {
    ...mapActions("payable", [
      "resetPayment",
      "confirmOrderWithAccountBalance"
    ]),
    async submit() {
      this.error = null;
      try {
        await this.confirmOrderWithAccountBalance();
      } catch (e) {
        console.log(e);
        this.error =
          "Não foi possível utilizar o seu saldo, tente novamente. Entre em contato com o nosso suporte se o problema persistir!";
      }
    }
  },
  computed: {
    ...mapState("payable", ["payable"])
  },
  mounted() {
    this.scrollTo("#account-balance");
  }
};
</script>

<template>
  <div id="account-balance" class="account-balance">
    <img src="/static/submenu-wallet.svg" />
    <h3>Confirmar agendamento com o seu saldo?</h3>

    <div class="warning" v-if="error">{{error}}</div>

    <p>Confirmaremos a sua limpeza utilizando o saldo da sua carteira em alguns instantes!</p>

    <div>
      <hr />

      <p class="warning">
        Não será gerada nenhuma cobrança adicional para essa limpeza.
      </p>
    </div>

    <div class="btn-group">
      <button class="btn bg-purple-outline" @click="resetPayment">Não, quero voltar</button>
      <button class="btn bg-purple" @click="submit">Sim, confirmar limpeza com o meu saldo</button>
    </div>
  </div>
</template>

<style scoped>
.account-balance {
  display: flex;
  flex-direction: column;
  align-items: center;
}
img {
  height: 50px;
  width: 50px;
}
h3 {
  text-align: center;
  margin-top: 16px;
  margin-bottom: 8px;
  padding-bottom: 16px;
  font-weight: 500;
  border-bottom: solid 1px #af006b;
}
.warning {
  margin-top: 12px;
  border-left: solid 1px #af006b;
  color: #af006b;
  padding-left: 8px;
  font-size: 12px;
}
p {
  text-align: center;
  font-size: 16px;
}
hr {
  width: 50px;
  border: 1px solid var(--pink);
}
.warning {
  font-size: 14px;
  color: var(--pink);
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Checkout/Payment/PaymentOptions/AccountBalance.vue